import { Button } from '@/components/button';
import { MaterialSymbolIcon } from '@/components/material-symbol-link';
import styles from './photo-wrapper.module.css';
import modalStyles from './photo-details-modal.module.css';
import { useState } from 'react';
import { Modal, ModalBody } from '@/components/modal/modal';
import { useTranslation } from '@/contexts/i18n-context';
import { ImageFileDto } from '@/api/api.schemas';
import { Img } from '@/components/img';

interface PreviewImageButtonProps {
  photo: ImageFileDto;
  alt: string;
}

export function PreviewImageButton({ photo, alt }: PreviewImageButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="textOnly"
        onClick={() => setIsModalOpen(true)}
        className={styles.previewButton}
      >
        <MaterialSymbolIcon name="search" className={styles.previewIcon} />
      </Button>

      <PreviewImageModal
        isOpen={isModalOpen}
        alt={alt}
        onClose={() => setIsModalOpen(false)}
        photo={photo}
      />
    </>
  );
}

interface PreviewImageModalProps {
  photo: ImageFileDto;
  alt: string;
  isOpen: boolean;
  onClose: () => void;
}

const translationBase = 'visit.photoUpload';
const modalTranslation = `${translationBase}.photoDetailsModal`;

function PreviewImageModal({ photo, alt, isOpen, onClose }: PreviewImageModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="h4">{t(`${modalTranslation}.title`)}</h2>
      <div className={modalStyles.imageContainer}>
        <Img src={photo.imageSrc} alt={alt} />
      </div>
      <ModalBody className={modalStyles.modalBody}>
        <div className={modalStyles.row}>
          <p className="semibold">{t(`${modalTranslation}.bodyLocationTitle`)}</p>
          <p>{t(`bodyLocation.${photo.bodyLocation ?? 'other'}`)}</p>
        </div>
        {photo.description && (
          <div className={modalStyles.row}>
            <p className="semibold">{t(`${modalTranslation}.descriptionTitle`)}</p>
            <p>{photo.description}</p>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}
